import type { Dispatch, FC, SetStateAction } from 'react';
import { useCallback } from 'react';
import type { MenuItemVariantDto } from '../../../../../../../../generated-api';
import type { CartAdditionOption } from '../../../../../../../../types/cart';
import { isRequiredHandled } from '../../../../../../../utils/customizations';
import OptionGroupSection from '../../../../../items/customization/OptionGroupSection';

interface Props {
  item: MenuItemVariantDto;
  options: CartAdditionOption[];
  onOptionsChange: (optionsOrFn: CartAdditionOption[] | ((prev: CartAdditionOption[]) => CartAdditionOption[])) => void;
}

const LeafComponentSection: FC<Props> = ({ item, options, onOptionsChange }) => {
  const setOptions: Dispatch<SetStateAction<CartAdditionOption[]>> = useCallback(
    (valueOrFn) => {
      onOptionsChange(valueOrFn);
    },
    [onOptionsChange]
  );

  return (
    <div className="flex flex-col gap-2">
      {item.description && <p className="text-small">{item.description}</p>}

      {item.allergens.length > 0 && (
        <p className="text-grey-dark text-small">{item.allergens.map((a) => a.name).join(', ')}</p>
      )}

      {item.optionGroups.map((optionGroup) => (
        <OptionGroupSection
          key={optionGroup.variantLinkId}
          optionGroup={optionGroup}
          setOptions={setOptions}
          defaultOptions={options}
          isRequiredHandled={isRequiredHandled(optionGroup, options)}
        />
      ))}
    </div>
  );
};

export default LeafComponentSection;
